export const cookiesConfig = {
  keys: {
    utm: 'utm',
  },
  maxAges: {
    oneDay: 60 * 60 * 24,
    oneYear: 60 * 60 * 24 * 365,
  },
};
